<template>
  <v-container fluid grid-list-md>
    <v-data-iterator
      :items="mixins"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
      :no-data-text="'Please add mixins'"
      content-tag="v-layout"
      row
      wrap
    >
      <template v-slot:item="props">
        <v-flex xs12 sm6 md4>
          <mixin
            :mixin="props.item"
            :edit="editLocal"
            :permissions="permissions"
            @editMixin="showEditMixinPopup"
          />
        </v-flex>
      </template>

      <template v-if="permissions.EDIT" v-slot:actions-append>
        <template v-if="editLocal">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                small
                color="success"
                :disabled="isResetMixin || isSendingMixin"
                v-on="on"
                @click="showNewMixinPopup"
              >
                <v-icon>add</v-icon>
              </v-btn>
            </template>
            <span>New mix</span>
          </v-tooltip>
          <v-btn
            @click="resetMixin"
            :loading="isResetMixin"
            :disabled="isResetMixin || isSendingMixin"
            flat
            color="warning"
          >
            Reset
          </v-btn>
          <v-btn
            :loading="isSendingMixin"
            :disabled="isSendingMixin || isResetMixin"
            @click="saveMixins"
            color="success"
          >
            Save
          </v-btn>
        </template>
      </template>
    </v-data-iterator>

    <template v-if="permissions.EDIT">
      <new-mixin-popup
        :dialog.sync="newMixinPopupStatus"
        :ingredientsGroups="ingredientsGroups"
        @newMixin="addNewMixin"
      />

      <edit-mixin-popup
        :dialog.sync="editMixinPopupStatus"
        :mixin="selectedMixin"
        :ingredientsGroups="ingredientsGroups"
        @saveMixin="updateMixin"
        v-if="selectedMixin"
      />

    </template>
  </v-container>
</template>

<script>
import Mixins from '@/orm/models/Mixins';
import Premixes from '@/orm/models/Premixes';
import MixRecipes from '@/orm/models/MixRecipes';
import MixingModule from '@/orm/models/MixingModule';
import MixinComponents from '@/orm/models/MixinComponents';
import IngredientGroups from '@/orm/models/IngredientGroups';
import CustomIngredients from '@/orm/models/CustomIngredients';

export default {
  name: 'mixins',
  props: {
    edit: {
      type: Boolean,
      default: () => false,
    },
    permissions: Object,
  },
  data() {
    return {
      rowsPerPageItems: [
        3,
        { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 },
      ],
      pagination: {
        rowsPerPage: -1,
      },
      isResetMixin: false,
      isSendingMixin: false,
      newMixinPopupStatus: false,
      editMixinPopupStatus: false,
      selectedMixin: null,
    };
  },
  watch: {
    async currentGroup() {
      await this.resetMixin();
    },
  },
  computed: {
    editLocal: {
      get() {
        return this.edit;
      },
      set(val) {
        this.$emit('update:edit', val);
      },
    },
    mixins() {
      return Mixins.all();
    },
    ingredientsGroups() {
      return IngredientGroups.all();
    },
  },
  methods: {
    async updateMixin({ mixin }) {
      const mix = JSON.parse(JSON.stringify(mixin));
      await Mixins.insertOrUpdate({ data: mix });
      this.selectedMixin = new Mixins();
    },
    editMixins() {
      this.editLocal = true;
    },
    showNewMixinPopup() {
      this.newMixinPopupStatus = true;
    },
    showEditMixinPopup(id) {
      this.selectedMixin = Mixins.find(id).$toJson();
      this.editMixinPopupStatus = true;
    },
    async addNewMixin({ mixin }) {
      await Mixins.insert({ data: mixin });
    },
    async resetMixin() {
      try {
        this.isResetMixin = true;
        const { params } = this.$route;
        const { mixes } = await MixingModule.$get({ params });
        await Mixins.create({ data: mixes.items || [] });
        const { recipes, premixes, custom_ingredients } = await MixinComponents.$get({ params });
        await IngredientGroups.$fetch();
        await CustomIngredients.create({ data: custom_ingredients });
        await Premixes.create({ data: premixes });
        await MixRecipes.create({ data: recipes });
      } finally {
        this.isResetMixin = false;
        this.editLocal = false;
      }
    },
    async saveMixins() {
      try {
        this.isSendingMixin = true;
        const mixinsLocal = this.mixins;
        const custom_ingredients_local = mixinsLocal.reduce((acc, mx) => {
          const cis = mx.custom_ingredients.map(ci => ({ name: ci.name, target: ci.target }));
          return acc.concat(cis);
        }, []);
        const { params } = this.$route;
        const { mixes } = await MixingModule.$create({
          params,
          data: {
            mixes: {
              items: mixinsLocal,
            },
            custom_ingredients: {
              items: custom_ingredients_local,
            },
          },
        });
        await Mixins.create({ data: mixes.items || [] });
        const { recipes, premixes, custom_ingredients } = await MixinComponents.$get({ params });
        await IngredientGroups.$fetch();
        await CustomIngredients.create({ data: custom_ingredients });
        await Premixes.create({ data: premixes });
        await MixRecipes.create({ data: recipes });
      } finally {
        this.isSendingMixin = false;
        this.editLocal = false;
      }
    },
  },
  components: {
    mixin: () => import('./mixin'),
    newMixinPopup: () => import('./newMixinPopup'),
    editMixinPopup: () => import('./editMixinPopup'),
  },
};
</script>
